export default __webpack_public_path__ + "5f0b83ad15ecb144362eb92f9e6b368f.svg";